import type { ComponentProps } from 'react';

import type { motion } from 'motion/react';

import { ChevronDownIcon, ChevronUpIcon } from '../Icons';
import * as Styled from './ScrollIndicator.styled';

interface Props extends Omit<ComponentProps<typeof motion.div>, 'ref'> {
  position: Styled.ScrollIndicatorPosition;
}

const ScrollIndicator = ({ position, ...rest }: Props) => {
  const { onClick, ...otherProps } = rest;
  return (
    <Styled.ScrollIndicator
      {...otherProps}
      $iconOpacity={((rest.style?.height as number) ?? 40) / 40}
      $position={position}
      onClick={onClick}
    >
      {position === 'top' ? (
        <ChevronUpIcon color="iconPrimaryInverse" size="sm" />
      ) : (
        <ChevronDownIcon color="iconPrimaryInverse" size="sm" />
      )}
    </Styled.ScrollIndicator>
  );
};

export default ScrollIndicator;
